import { useTranslation } from '~/_shared/utils/hooks';
import { ExportReportPrintPageWrapperComponent } from '~/exportReport/printPage/exportReportPrintPageWrapper.component';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { ExportReportTemplateRendererComponent } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import { useExportReportData } from '~/exportReport/useExportReportData';
import { useExportReportParams } from '~/exportReport/useExportReportParams';
import type { ExportReportDriveTimePolygonParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

type MapExportReportPreviewDriveTimePolygonProps = Readonly<{
  params: ExportReportDriveTimePolygonParams;
  template: ReportTemplate;
}>;

export const ExportReportPrintPageDriveTimePolygonComponent = ({
  template, params,
}: MapExportReportPreviewDriveTimePolygonProps) => {
  const { tableColumns } = useExportReportParams();
  const { getDemographicData, getDemographicLabel } = useExportReportData({
    tableColumns,
    template,
  });
  const [t] = useTranslation();

  return (
    <ExportReportPrintPageWrapperComponent>
      <ExportReportTemplateRendererComponent
        template={template}
        tableColumns={tableColumns}
        summaryProps={{
          heading: t('Drive Time Polygon'),
        }}
        mapProps={{
          type: params.type,
          paths: params.data.paths,
        }}
        getDemographicLabel={getDemographicLabel}
        getDemographicData={getDemographicData}
      />
    </ExportReportPrintPageWrapperComponent>
  );
};
